import {
  TextInput,
  Grid,
  Stack,
  Button,
  Textarea,
  Select,
  LoadingOverlay,
} from "@mantine/core";
import { useMutation } from "@apollo/client";
import { showNotification } from "@mantine/notifications";
import { useForm } from "@mantine/form";
import { MANAGE_STOCK } from "apollo/mutuations";
import { customLoader } from "components/utilities/loader";

const ManageStock = ({fetchParentData, editId, setOpenedEdit, fetchData }) => {
  const form = useForm({
    initialValues: {
      quantity: null,
      reason: "",
      type: null,
      minimum_stock_level: 0,
    },
  });

  const [manageStock, { loading: manageStockLoading }] =
    useMutation(MANAGE_STOCK);

  const submit = () => {
    manageStock({
      variables: {
        stock_id: editId,
        type: form.values.type,
        reason: form.values.reason,
        quantity: parseInt(form.values.quantity),
      },
      onCompleted(data) {
        showNotification({
          color: "green",
          title: "Success",
          message: "Stock Managed Successfully",
        });
        fetchData();
        fetchParentData()
        setOpenedEdit(false);
      },
      onError(error) {
        setOpenedEdit(true);
        showNotification({
          color: "red",
          title: "Error",
          message: `${error}`,
        });
      },
    });
  };

  const setTypeDropDownValue = (val) => {
    form.setFieldValue("type", val);
  };
  return (
    <>
      <LoadingOverlay
        visible={manageStockLoading}
        color="blue"
        overlayBlur={2}
        loader={customLoader}
      />
      <form onSubmit={form.onSubmit(() => submit())}>
        <Stack>
          <Grid>
            <Grid.Col span={3}>
              <TextInput
                required
                type="number"
                label="Quantity"
                placeholder="Quantity"
                {...form.getInputProps("quantity")}
              />
              <Textarea
                placeholder="Your reason"
                label="Your reason"
                required
                {...form.getInputProps("reason")}
              />
            </Grid.Col>
            <Grid.Col span={3}>
              <Select
                data={[
                  { label: "RELEASE", value: "RELEASE" },
                  { label: "HOLD", value: "HOLD" },
                  { label: "MOVE", value: "MOVE" },
                  { label: "ADD", value: "ADD" },
                  { label: "REMOVE", value: "REMOVE" },
                ]}
                value={form.getInputProps("type")?.value}
                onChange={setTypeDropDownValue}
                label="Type"
                placeholder="Pick a type"
                searchable
              />
            </Grid.Col>
          </Grid>
          <Grid>
            <Grid.Col span={6}>
              <Button
                style={{
                  width: "25%",
                  marginTop: "15px",
                  backgroundColor: "#FF6A00",
                  color: "#FFFFFF",
                }}
                type="submit"
                fullWidth
              >
                Submit
              </Button>
            </Grid.Col>
          </Grid>
        </Stack>
      </form>
    </>
  );
};

export default ManageStock;
